import React, { useEffect, useState } from "react";
import { fetchMessageBody } from "./dealApi";

// Email HTML comes from arbitrary senders, so it is only ever rendered inside an
// iframe with an empty `sandbox` (no scripts, no same-origin, no forms, no
// navigation) — never injected into this page's DOM, where it could read the
// session token. Falls back to preformatted text when there is no HTML.
export const EmailFrame = ({ html, text }) => {
  if (html) {
    return (
      <iframe
        title="Email body"
        sandbox=""
        srcDoc={html}
        className="deal-history-email-frame"
      />
    );
  }
  return <pre className="deal-history-email-text">{text}</pre>;
};

// `apiPath` defaults to the deal's; see dealApi.fetchMessageBody.
const EmailBody = ({ dealId, apiPath = `/api/deals/${dealId}`, messageId }) => {
  const [body, setBody] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchMessageBody(apiPath, messageId)
      .then((data) => {
        if (!cancelled) setBody(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      });
    return () => {
      cancelled = true;
    };
  }, [apiPath, messageId]);

  if (error) return <p className="error">Error: {error}</p>;
  if (!body) return <p className="loading">Loading...</p>;
  return <EmailFrame html={body.html} text={body.text} />;
};

export default EmailBody;
